import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { getAllGorouhMoshtari } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import ExpandCustomerGroup from "./ExpandCustomerGroup";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

export default function CustomerGroups() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [accordionExpanded, setAccordionExpanded] = useState(-1);
  const { grouhMoshtari } = useSelector((state) => ({
    grouhMoshtari: state.customer.allGorohMoshtariData,
  }));
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = { KeyGroup: read("groupKey"), KeyUser: read("userKey") };
        await dispatch(getAllGorouhMoshtari(params));
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="customer-groups-section">
      <span className="normalTitle">{t("customerGroups")}</span>
      <Grid item xs={12} className="px-0 groups-list">
        {loading ? (
          <Grid item xs={12}>
            <Skeleton
              variant="text"
              animation="wave"
              width={"100%"}
              className="mb-4"
            />
            <Skeleton
              variant="text"
              animation="wave"
              width={"100%"}
              className="mb-4"
            />
            <Skeleton
              variant="text"
              animation="wave"
              width={"100%"}
              className="mb-4"
            />
            <Skeleton
              variant="text"
              animation="wave"
              width={"100%"}
              className="mb-4"
            />
            <Skeleton
              variant="text"
              animation="wave"
              width={"100%"}
              className="mb-4"
            />
            <Skeleton variant="text" animation="wave" width={"100%"} />
          </Grid>
        ) : (
          grouhMoshtari.map((group, i) => {
            return (
              <div key={i} className="mb-2 paper-no-padding">
                <ExpandCustomerGroup
                  row={grouhMoshtari[i]}
                  expanded={accordionExpanded}
                  onChangeExpanded={(value) => setAccordionExpanded(value)}
                />
              </div>
            );
          })
        )}
      </Grid>
    </div>
  );
}
